import { useRef, useState, useEffect } from 'react';

// Modal component with a SignatureModal pad inside it
const SignatureModal = ({ isOpen, onClose, onSaveSignature }) => {
  const canvasRef = useRef(null);
  const containerRef = useRef(null); // Reference to the parent div
  const [isDrawing, setIsDrawing] = useState(false);
  const [lastX, setLastX] = useState(0);
  const [lastY, setLastY] = useState(0);
  const [canvasSize, setCanvasSize] = useState({ width: 0, height: 0 });

  // Function to update the canvas size
  const updateCanvasSize = () => {
    if (containerRef.current && canvasRef.current) {
      const width = containerRef.current.offsetWidth;
      const height = containerRef.current.offsetHeight;
      setCanvasSize({ width, height });
      canvasRef.current.width = width;
      canvasRef.current.height = height;
    }
  };

  useEffect(() => {
    // Set initial canvas size
    updateCanvasSize();

    // Update canvas size on window resize
    window.addEventListener('resize', updateCanvasSize);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener('resize', updateCanvasSize);
    };
  }, []);  // Empty dependency array ensures it runs only once on mount

  useEffect(() => {
    if (canvasRef.current) {
      const ctx = canvasRef.current.getContext('2d');
      ctx.lineWidth = 5;
      ctx.lineCap = 'round';
      ctx.strokeStyle = 'black';
    }
    drawTextInCenter('Sign here.');
  }, []);


  const drawTextInCenter = (text) => {
    const ctx = canvasRef.current.getContext('2d');
    ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height); // Clear canvas first
    if (!isDrawing) { // Only draw text if not drawing
      ctx.fillStyle = 'gray';
      ctx.font = '24px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(text, canvasRef.current.width / 2, canvasRef.current.height / 2);
    }
  };

  const [drawStarted,setDrawStarted] = useState(false);
  useEffect(() => {
    if(drawStarted){
      drawTextInCenter('');
    }
  }, [drawStarted]);

  const startDrawing = (e) => {
    setDrawStarted(true);

  
    const rect = canvasRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    // Check if the click is within the box to start drawing
    if (x >= 0 && x <= canvasSize.width && y >= 0 && y <= canvasSize.height) {
      setIsDrawing(true);
      setLastX(x);
      setLastY(y);
    }
  };

  const draw = (e) => {
    if (!isDrawing) return;

    if(drawStarted){
      setDrawStarted(true);
    }

    const rect = canvasRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    // Check if within the box
    if (x >= 0 && x <= canvasSize.width && y >= 0 && y <= canvasSize.height) {
      const ctx = canvasRef.current.getContext('2d');
      ctx.beginPath();
      ctx.moveTo(lastX, lastY);
      ctx.lineTo(x, y);
      ctx.stroke();
      setLastX(x);
      setLastY(y);
    }
  };

  const stopDrawing = () => {
    setIsDrawing(false);
  };

  const clearCanvas = () => {
   
    const ctx = canvasRef.current.getContext('2d');
    ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
    drawTextInCenter('Sign here.');
    setDrawStarted(false);
   
  };

  const saveSignature = () => {
    const dataURL = canvasRef.current.toDataURL('image/png');
    onSaveSignature(dataURL);  // Pass the data URL to the parent
    onClose();
  };

  return (
    <>
    <div className='row'>
      <div
        className='col-md-12 d-flex justify-content-center'
        style={{  width:"100%", height:'60vh'}} // This gives dynamic size to the parent container
        ref={containerRef}
      >
 
        <canvas
          className='border border-label-primary bg-label-dark rounded border border-dashed border-5'
          ref={canvasRef}
          onMouseDown={startDrawing}
          onMouseMove={draw}
          onMouseUp={stopDrawing}
          // onMouseLeave={stopDrawing}
        />
      </div>


    

      {/* <button type="button" onClick={clearCanvas}>Clear</button>
      <button type="button" onClick={saveSignature}>Save</button>
      <button type="button" onClick={onClose}>Close</button> */}

    </div>
      <div className="row mt-4">
        <span className='mb-4 fw-bold'>
          By signing this document with an electronic signature, you agree that such signature will be as valid as handwritten signatures to the extend allowed by local law.
        </span>
        
        <div className="col-12 d-flex justify-content-between px-3">
          <button type="button" className="btn btn-label-secondary" onClick={clearCanvas}>
            <i className="bx bx-trash bx-sm ms-sm-n2" />
            <span className="align-middle d-sm-inline-block d-none">
              Clear Signature
            </span>
          </button>
          <button type="button" className="btn btn-primary" onClick={saveSignature}>
            <span className="align-middle d-sm-inline-block  d-none  me-sm-1">
            Save Signature
            </span>
            <i className="bx bx-save bx-sm me-sm-n2" />
          </button>
        </div>
      </div>
    </>
  );
};

export default SignatureModal;
